<script setup>
import { onMounted, ref } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';
import MessageApi from 'dashboard/api/inbox/message';
import avatarCache from './whatsappMentionAvatarCache';

const props = defineProps({
  conversationId: { type: Number, required: true },
  jid: { type: String, required: true },
  name: { type: String, required: true },
  src: { type: String, default: '' },
  size: { type: Number, default: 16 },
});

const resolvedSrc = ref(props.src);

onMounted(async () => {
  if (resolvedSrc.value) return;
  const key = `${props.conversationId}:${props.jid}`;
  let cached = avatarCache.get(key);
  if (!cached || cached.expiresAt < Date.now()) {
    const promise = MessageApi.getWhatsappGroupAvatar(props.conversationId, props.jid)
      .then(response => response.data.avatar_url || '')
      .catch(() => '');
    cached = { promise, expiresAt: Date.now() + 5 * 60 * 1000 };
    avatarCache.set(key, cached);
    promise.then(url => {
      cached.expiresAt = Date.now() + (url ? 30 : 5) * 60 * 1000;
    });
  }
  resolvedSrc.value = await cached.promise;
});
</script>

<template>
  <Avatar :name="name" :src="resolvedSrc" :size="size" rounded-full />
</template>
